













import { defineComponent, toRefs, computed } from '@vue/composition-api';
import Filter from './filter.vue';
import { i18n } from '../../../../i18n';
import { SpuInStorefrontFilter } from '@tt4b/ttam-enums';

const name = 'ttam-product-details-header-storefront';
export default defineComponent({
  name,
  components: {
    InStorefrontFilter: Filter,
  },
  props: {
    filter: {
      type: Number,
      default: SpuInStorefrontFilter.ALL,
    },
  },
  setup(props, { emit }) {
    const { filter } = toRefs(props);
    const options = computed(() => [
      {
        label: i18n.t('module_common_all'),
        value: SpuInStorefrontFilter.ALL,
      },
      {
        label: i18n.t('module_creative_in_storefront'),
        value: SpuInStorefrontFilter.IN,
      },
      {
        label: i18n.t('module_creative_not_in_storefront'),
        value: SpuInStorefrontFilter.NOT_IN,
      },
    ]);
    const hasFilter = computed(() => filter.value !== SpuInStorefrontFilter.ALL);
    const select = val => {
      emit('change', val);
    };
    return {
      name,
      options,
      select,
      hasFilter,
    };
  },
});
